// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'select2';
import 'select2/dist/js/i18n/sk';


export default class SelectDesign extends WebComponent {
	didMount () {
		const element = this.element;
		const isIE = /MSIE|Trident/.test(window.navigator.userAgent);
		if(!isIE){
			$(element).select2({
				language: 'sk',
				minimumResultsForSearch: Infinity
			}).on('change', function() {
				if(element.getAttribute('data-auto-submit') === 'true') {
					const formElement = element.closest('form');
					const submitElement = formElement.querySelector('button[type="submit"]');
					submitElement.click();
				}
			});
			if(element.getAttribute('data-tags') === 'true') {
				$(element).select2({
					tags: true
				});
			}

			if(element.getAttribute('data-ajax') === 'true') {
				const dataAjaxUrl = element.getAttribute('data-url');
				$(element).select2({
					ajax: {
						url: dataAjaxUrl,
						dataType: 'json',
						type: 'POST',
						delay: 250,
						data: function (params) {
							// console.log(params.term);
							return {
								q: params.term
							};
						},
						processResults: function (data) {
							// console.log(data);
							return {
								results: data.items
							};
						},
						cache: true
					},
					language: 'sk',
					placeholder: 'Vyhledať',
					minimumInputLength: 1,
				});
			}
		} else {
			element.classList.add('form-control--visible');
			element.addEventListener('change', function() {
				if(element.getAttribute('data-auto-submit') === 'true') {
					const formElement = element.closest('form');
					const submitElement = formElement.querySelector('button[type="submit"]');
					submitElement.click();
				}
			});
		}
	}
}




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/SelectDesign.js